/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNameRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNameRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountNameRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNameRegexQueryOperator>): ServiceAccountNameRegexQueryOperator {
        let obj = Object.assign(new ServiceAccountNameRegexQueryOperator(), model);
        ServiceAccountNameRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNameRegexQueryOperator>): ServiceAccountNameRegexQueryOperator {
        if (!model) return null;
        return ServiceAccountNameRegexQueryOperator.newInstance(<ServiceAccountNameRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNameRegexQueryOperator) {
        if (!obj) return;

        models.ServiceAccountNameRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNameRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNameRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.service_account_name) {
            models.Regex.fixupPrototype(this.service_account_name);
        }
    }

    /**
     * Service account name regex pattern
     */
    service_account_name: models.Regex;

}
